import React from 'react'
import { SobreNosotrosUi } from '../../../../Desktop/components/ui/SobreNosotrosUi/SobreNosotrosUi'
import { Header } from '../../../../Desktop/components/layouts/Header/Header'

export const SobreNosotrosLayouts = () => {
  return (
    <div>
        <Header/>
        <SobreNosotrosUi/>
    </div>
  )
}
